import DeleteModal from "../components/ui/DeleteModal";
export default {
  components: {
    DeleteModal
  },

  data() {
    return {
      showDeleteModal: false,
    }
  },

  methods: {
    openDeleteModal() {
      this.showDeleteModal = true;
    },

    closeDeleteModal() {
      this.showDeleteModal = false;
    }
  }
}